export default [{
  path: '/customer/details',
  name: 'customer-details',
  redirect: '/customer/details/info',
  title: '顾客详情',
  component: () => import('@/views/customer/template/details/index'),
  children: [{
    path: '/customer/details/info',
    name: 'customer-info',
    title: '顾客详情',
    component: () => import('@/views/customer/template/details/template/info')
  }, {
    path: '/customer/details/package',
    name: 'customer-package',
    title: '顾客详情', // 会员套餐
    component: () => import('@/views/customer/template/details/template/package')
  },
  {
    path: '/customer/details/gift',
    name: 'customer-gift',
    title: '顾客详情', // 赠品记录
    component: () => import('@/views/customer/template/details/template/gift')
  }, {
    path: '/customer/details/bespeak',
    name: 'customer-bespeak',
    title: '顾客详情', // 预约记录
    component: () => import('@/views/customer/template/details/template/bespeak')
  }, {
    path: '/customer/details/consume',
    name: 'customer-consume',
    title: '顾客详情', // 消费记录
    component: () => import('@/views/customer/template/details/template/consume')
  }, {
    path: '/customer/details/recharge',
    name: 'customer-recharge',
    title: '顾客详情', // 充值记录
    component: () => import('@/views/customer/template/details/template/recharge')
  }, {
    path: '/customer/details/record',
    name: 'customer-record',
    title: '顾客详情', // 房间记录
    component: () => import('@/views/customer/template/details/template/record')
  }]
}, {
  path: '/customer/member',
  name: 'customer-member',
  title: '会员详情', // 房间记录
  component: () => import('@/views/customer/member')
}];
